import React from 'react'
import './footer.css'
import { FaFacebookF } from 'react-icons/fa'

const Footer = () => {
  return (
    <footer>
      <a href="#home" className='footer__logo'>Angela Tseng</a>

      <ul className='permalinks'>
        <li><a href="#home">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#testimonials">Certificates</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.facebook.com/tsengyt603/" target="_blank" rel="noreferrer">
          <FaFacebookF />
        </a>
      </div>

      <div className="footer__copyright">
        <small>&copy; Angela Tseng. All rights reserved.</small>
      </div>
    </footer>
  )
}

export default Footer
